import { MerchantResponse } from '@repo/api/endpoints/merchant';
import { LimitMerchant, OfferLimit, ProviderType } from '@repo/shared/types';

import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import type { LoanStoreData } from '@/components/loan-process/store/loan-process.store';
import type { HandleSubmitParams } from '@/components/loan-process/loan-stages/stage-2/stage-two';

import { AgreementAndApprovalsContent } from './agreement-and-approvals-content';
import { AgreementAndApprovalsContextProvider } from './context/agreement-and-approvals-context-provider';

interface AgreementAndApprovals {
  loanData: LoanStoreData;
  loanLimit: LimitMerchant | OfferLimit;
  merchantResponseData: MerchantResponse;
  hasBeenEditRequestSent: boolean;
  isApplicationProcessing: boolean;
  handleSubmitForm: (data: HandleSubmitParams) => void;
  handleAcceptTerms: () => void;
  selectedProvider: ProviderType;
}

export function AgreementAndApprovals(props: AgreementAndApprovals) {
  useLoanProcessSetCurrentModalState('AgreementAndApprovals');

  return (
    <AgreementAndApprovalsContextProvider>
      <AgreementAndApprovalsContent {...props} />
    </AgreementAndApprovalsContextProvider>
  );
}
